import { CalendarMonth, FormatListBulleted, EventAvailable } from "@mui/icons-material";
import { Unstable_Grid2 as Grid, IconButton, Tooltip } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import { Link } from "react-router-dom";

type ToggleBetweenCalendarAndListProps = {
    setView: React.Dispatch<React.SetStateAction<"calendar" | "list">>;
    style?: SxProps<Theme>;
};

export const ToggleBetweenCalendarAndList = ({ setView, style}: ToggleBetweenCalendarAndListProps) => {
    return (
        <Grid container spacing={2} sx={{ alignItems: "center", ...style }}>
            <Grid>
                <Tooltip title="Calendário">
                <IconButton onClick={() => setView("calendar")}>
                    <CalendarMonth />
                </IconButton>
                </Tooltip>
            </Grid>
            <Grid>
                <Tooltip title="Lista">
                <IconButton onClick={() => setView("list")}>
                    <FormatListBulleted />
                </IconButton>
                </Tooltip>
            </Grid>
            <Grid>
                <Tooltip title="Horários Reservados">
                    <IconButton component={Link} to="/reserved-slots">
                        <EventAvailable />
                    </IconButton>
                </Tooltip>
            </Grid>
        </Grid>
    );
};
